// extracted by mini-css-extract-plugin
export var cardTitle = "_j1-1";
export var commentBubble = "_j1-e";
export var commentForm = "_j1-a";
export var commentInput = "_j1-b";
export var commentLabel = "_j1-d";
export var commentPrompt = "_j1-9";
export var csatCard = "_j1-0";
export var feedbackSection = "_j1-7";
export var starDisabled = "_j1-6";
export var starEmpty = "_j1-5";
export var starFilled = "_j1-4";
export var starWrapper = "_j1-3";
export var starsContainer = "_j1-2";
export var submittedComment = "_j1-c";
export var thankYouText = "_j1-8";